import { ContainerNamePrefix, OperateBoardEnum } from '../common/Constant';
import Layout from '../common/Layout';
import Component from '../core/Component';
import { createElement, removeFromParentById } from '../utils/Dom';
import { deepCopy } from '../utils/extends';
import DoodleView from './DoodleView';
import log from 'loglevel';

/**
 * @export
 * @class AbstractContainer
 * @extends {Component}
 */
export default class AbstractContainer extends Component {
  constructor(elId, uid, opts) {
    super();
    log.debug('AbstractContainer constructor');
    this.type = '';

    this._id = uid;
    this._root = elId;

    this._editable = false;
    this._cacheable = false;
    this.selected = false;
    this.allData = [];

    // 涂鸦实例
    this.doo = null;
    // 数据存放地
    this._store = null;
    // 布局实例
    this.layout = new Layout();

    if (typeof opts === 'string') {
      opts = JSON.parse(opts);
    }

    this._opts = deepCopy(this.defaultOption, opts);

    // 创建一个drag div
    const rnd = ~~(Math.random() * 89999) + 10000;
    const canvasId = `${ContainerNamePrefix.Drag}-${rnd}`;
    this.dragAreaId = canvasId;
    this._initDoodle();
    log.debug('AbstractContainer constructor end');
  }

  /**
   * 用命令操作涂鸦工具
   *
   * @param {*} type 命令
   * @param {*} args 命令参数
   * @memberof AbstractContainer
   */
  operateDoodle(type, ...args) {
    if (!this.doo) {
      return;
    }
    log.debug('AbstractContainer operateDoodle');
    this.doo.operateDoodle(type, ...args);
    log.debug('AbstractContainer operateDoodle end');
  }

  getDoodoleCurrentId() {
    if (!this.doo) {
      return -1;
    }
    return this.doo.getDoodoleCurrentId();
  }

  /**
   * 设置大小
   *
   * @param {*} w
   * @param {*} h
   * @memberof AbstractContainer
   */
  resize(w, h) {
    this.layout.resizeContainer(this.root, w, h);
    this.layout.resizeContainer(this.dragAreaId, w, h);

    if (this.doo) {
      this.doo.operateDoodle('setSize', w, h);
    }
  }

  destroy() {
    super.destroy();
    if (this.doo) {
      this.doo.destroy();
      this.doo = null;
    }

    removeFromParentById(this.dragAreaId);
  }

  setSelected(val) {
    this.selected = val;
    if (val) {
      this.operateDoodle(OperateBoardEnum.ClearData);
      this.operateDoodle(OperateBoardEnum.SaveData);
    }
  }
  _initContainer() {
    let dragArea = createElement('div', { id: this.dragAreaId }, { width: '100%', height: '100%' });
    let parent = document.getElementById(this.root);
    parent.appendChild(dragArea);

    this.dragArea = dragArea;

    let w = this.option.basic.width || 200;
    let h = this.option.basic.height || 150;
    this.option.basic.width = w;
    this.option.basic.height = h;
    this.layout.initContainer(this.root, w, h);

    // 声明一下dragArea的参数
    dragArea.style.width = '100%';
    dragArea.style.height = '100%';
    dragArea.style.position = 'absolute';
    dragArea.style.overflow = 'hidden';
  }

  _initDoodle() {
    this.destroy();
    removeFromParentById(`${ContainerNamePrefix.CanvasContainer}-${this.id}`);

    this.doo = new DoodleView(this.option);
    this._initContainer();
    this.doo.initDoodle(this.dragAreaId);
  }

  /**
   * 设置数据
   *
   * @memberof AbstractContainer
   */
  set data(v) {
    log.info(`收到数据 set data, ${v}`);
    log.info(`收到数据 set data, ${this.doo.currentId}`);
    if (typeof v === 'string') {
      v = JSON.parse(v);
    }
    if (!v) return;
    if (v.cid !== this.id) {
      return;
    }

    let datas = v.command;
    datas.forEach(data => {
      switch (data.event) {
        case 'doodle':
          const cw = this.store.getKV('cw');
          const ch = this.store.getKV('ch');
          const drawData = data.data;
          if (!drawData || (drawData.pageId && this.doo.currentId && drawData.pageId !== this.doo.currentId)) {
            break;
          }

          this.operateDoodle(OperateBoardEnum.SetCanvasSize, drawData.cw, drawData.ch);
          this.operateDoodle(OperateBoardEnum.Trigger, data.type, JSON.stringify(drawData));
          this.operateDoodle(OperateBoardEnum.SetSize, cw, ch);

          // 收到清空画布的消息，清空画笔数据缓存
          if (data.type === '*remove_all') {
            this.operateDoodle(OperateBoardEnum.ClearData);
            this.operateDoodle(OperateBoardEnum.SaveData);
          }
          break;
        default:
          break;
      }
    });
  }

  // 回放场景下seek模式设置绘制数据，解决性能问题
  setDrawingForSeek(arr) {
    // console.log('最终渲染的的方法 setDrawDataForSeek1:', arr);
    let parsedArr = []; // 转换后的数组
    for (const item of arr) {
      const newItem = typeof item === 'string' ? JSON.parse(item) : item;
      if (!newItem || newItem.cid !== this.id) {
        parsedArr = null;
        break;
      }
      for (const cmd of newItem.command) {
        if (cmd.event === 'doodle') {
          let drawData = cmd.data;
          if (!drawData || (drawData.pageId && this.doo.currentId && drawData.pageId !== this.doo.currentId)) {
            continue;
          } else {
            drawData.opType = cmd.type;
            parsedArr.push(drawData); // 只存储绘制相关数据
          }
        }
      }
    }
    if (!parsedArr || parsedArr.length === 0) return;
    // console.log('最终渲染的的方法 setDrawDataForSeek2:', dooJsonData);
    this.operateDoodle(OperateBoardEnum.SetCanvasSize, parsedArr[0].cw, parsedArr[0].ch);

    const cw = this.store.getKV('cw');
    const ch = this.store.getKV('ch');
    const size = { cw, ch };
    this.operateDoodle(OperateBoardEnum.LoadManydrawing, parsedArr, size);
  }

  setAllData(allData) {
    this.allData = allData;
  }

  get option() {
    return this._opts;
  }

  get root() {
    return this._root;
  }

  get id() {
    return this._id;
  }

  get board() {
    return this.doo;
  }

  get pageInfo() {
    let obj = {};
    obj.doodle = (this.doo && this.doo.allData) || {};
    return obj;
  }

  set editable(v) {
    log.debug(`set editable, v: ${v}`);
    this._editable = v;
    this.operateDoodle(OperateBoardEnum.Editable, v);
    log.debug('set editable end');
  }

  get editable() {
    return this._editable;
  }

  set cacheable(v) {
    this._cacheable = v;
    this.operateDoodle(OperateBoardEnum.Cacheable, v);
  }

  get cacheable() {
    return this._cacheable;
  }

  set store(val) {
    this._store = val;
    if (this.doo) {
      this.doo.store = val;
    }
    this.store.setKV('cid', this.id);
    this.store.setKV('originW', this.option.basic.width);
    this.store.setKV('originH', this.option.basic.height);
    this.store.setKV('cw', this.option.basic.width);
    this.store.setKV('ch', this.option.basic.height);
    this.store.setKV('rootId', this.root);
    this.store.setKV('type', this.type);
    this.store.setKV('dragId', this.dragAreaId);
  }

  get store() {
    return this._store;
  }

  get defaultOption() {
    return {
      control: {},
      advance: {
        multiTouch: false,
        zoomOption: {
          maxZoom: 4,
          minZoom: 1
        }
      },
      basic: {
        width: 500,
        height: 500,
        backgroundColor: '#ffc0f000',
        // urlBase: '//t-static01-open.e.vhall.com/document/',
        // urlBase: '//static01-open.e.vhall.com/document/',
        uploadBase: '//upload.vhall.com/'
      }
    };
  }
}
